const EXPRESSION = {
  VALUE: 0,
  VARIABLE: 1,
  DEEP_VARIABLE: 2,
  CONDITION: 3,
  NOT: 4,
  AND: 5,
  OR: 6,
}

export default EXPRESSION
